import { useEffect, useState } from 'react';
import {
  acquireBlobObjectUrl,
  releaseBlobObjectUrl,
} from '../utils/blobObjectUrlCache';

/**
 * Acquires a shared, ref-counted object URL for `cacheKey` + `blob`.
 * Releases (and may revoke) on unmount or when key/blob changes.
 */
export function useBlobObjectUrl(
  cacheKey: string | null | undefined,
  blob: Blob | null | undefined,
): string | null {
  const [acquired, setAcquired] = useState<{
    key: string;
    url: string;
  } | null>(null);

  useEffect(() => {
    if (cacheKey == null || cacheKey.length === 0 || blob == null) {
      return;
    }

    const key = cacheKey;
    const url = acquireBlobObjectUrl(key, blob);
    let cancelled = false;

    queueMicrotask(() => {
      if (!cancelled) {
        setAcquired({ key, url });
      }
    });

    return () => {
      cancelled = true;
      releaseBlobObjectUrl(key);
    };
  }, [blob, cacheKey]);

  if (cacheKey == null || cacheKey.length === 0 || blob == null) {
    return null;
  }

  if (acquired == null || acquired.key !== cacheKey) {
    return null;
  }

  return acquired.url;
}
